





import app from "@/app";
import { SXCompany, SXSector } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WCompanyEdit extends BaseComponent {
	@Prop({ type: SXCompany, required: true })
	company!: SXCompany;

	title = "SX_LANG_COMPANY_EDIT";
	loading = false;

	get customData() {
		return this.ux_custom_data(this.company.data);
	}
	get form() {
		return getForm(this.sectors, this.company, this.customData);
	}
	get sectors() {
		return app.services.sectors.list();
	}

	sendForm(event: any) {
		let form: HTMLFormElement = event.target,
			required = [
				SXCompany.COL_SECTOR_ID,
				SXCompany.COL_NAME,
				SXCompany.COL_DESCRIPTION
			],
			fv = app.getFormValidator(form, required);

		if (fv.validate()) {
			let item = new SXCompany(this.company.toObject()),
				data: any = {},
				customData = {
					...this.customData,
					bg_color: fv.getField("bg_color"),
					txt_color: fv.getField("txt_color")
				};

			data[SXCompany.COL_DATA] = JSON.stringify(customData);

			[
				SXCompany.COL_SECTOR_ID,
				SXCompany.COL_NAME,
				SXCompany.COL_DESCRIPTION,
				SXCompany.COL_VISIBILITY
			].forEach(function(name) {
				data[name] = fv.getField(name);
			});

			if (!fv.getField(SXCompany.COL_VISIBILITY)) {
				data[SXCompany.COL_VISIBILITY] = false;
			}

			if (!item.doHydrate(data).isClean()) {
				app.services.companies.updateItem(item, function() {
					app.router.goBack();
				});
			} else {
				app.router.goBack();
			}
		}
	}

	created() {
		if (!this.sectors.length) {
			let ctx = this,
				always = () => (ctx.loading = false);
			ctx.loading = true;
			app.services.sectors.loadSectors(always, false);
		}
	}
}

const getForm = function(
	sectors: SXSector[],
	company: SXCompany,
	custom_data: any
) {
	let options = sectors.map(function(item) {
		return {
			attrs: { value: item.id },
			i18n: item.name
		};
	});

	return {
		fields: {
			sector: {
				field: "select",
				label: { i18n: "SX_LANG_SECTOR" },
				attrs: {
					name: SXCompany.COL_SECTOR_ID,
					value: company.sector_id
				},
				options: options
			},
			name: {
				field: "input",
				label: { i18n: "SX_LANG_NAME" },
				attrs: {
					name: SXCompany.COL_NAME,
					minlength: 3,
					maxlength: 60,
					autocomplete: "off",
					value: company.name
				}
			},
			description: {
				field: "textarea",
				label: { i18n: "SX_LANG_DESCRIPTION" },
				attrs: {
					name: SXCompany.COL_DESCRIPTION,
					minlength: 3,
					value: company.description
				}
			},
			bg_color: {
				field: "input",
				label: { i18n: "SX_LANG_BG_COLOR" },
				attrs: {
					name: "bg_color",
					type: "color",
					value: custom_data["bg_color"] || "#233D7D"
				}
			},
			txt_color: {
				field: "input",
				label: { i18n: "SX_LANG_TXT_COLOR" },
				attrs: {
					name: "txt_color",
					type: "color",
					value: custom_data["txt_color"] || "#FFFFFF"
				}
			},
			visibility: {
				field: "checkbox",
				label: { i18n: "SX_LANG_VISIBILITY" },
				attrs: {
					name: SXCompany.COL_VISIBILITY,
					checked: company.visibility
				}
			},
			submit: {
				field: "submit",
				i18n: "OO_LANG_VALIDATE_BTN"
			}
		}
	};
};
